<template>
  <div v-if="!appLoading" class="on-boarding-flow-wrapper">
    <template v-if="monthReview">
      <month-review-intro v-if="showIntro"
                          @done="showFlow"
                          @skip-to-cashflow="finishMonthReview"></month-review-intro>
      <month-review-flow v-else :start-index="startIndex" @next-clicked="onNextClicked" @month-review-done="finishMonthReview"></month-review-flow>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import MonthReviewFlow from './MonthReviewFlow';
import { chooseFlow } from './parse-transactions';
import casfhlowHistory from '../../../../../store/utilities/cashflow-history';
import MonthReviewIntro from './MonthReviewIntro';

export default {
  name: 'OnBoardingFlowWrapper',
  components: {
    MonthReviewIntro,
    MonthReviewFlow,
  },
  data() {
    return {
      monthReview: false,
      showIntro: true,
      startIndex: 0,
    };
  },
  async created() {
    this.startLoading();
    const currentIndexFromLocalStorage = localStorage.getItem(this.localStorageKey);
    if (currentIndexFromLocalStorage) {
      this.showIntro = false;
      this.startIndex = +currentIndexFromLocalStorage;
    }

    await this.initBudgets({ budgetDate: this.budgetDate });
    this.monthReview = await chooseFlow(this.cashflowUITree);
    this.doneLoading();

    if (!this.monthReview) {
      await this.finishMonthReview();
    }
  },
  computed: {
    ...mapGetters('loader', ['appLoading']),
    ...mapState('cashflowView', ['cashflowUITree']),
    ...mapState('session', ['customerId']),
    budgetDate() {
      return casfhlowHistory.getPrevBudgetDate(casfhlowHistory.getCurrentBudgetDate());
    },
    localStorageKey() {
      return `riseup.pastmonth.index.${this.customerId}`;
    },
  },
  methods: {
    ...mapActions('loader', ['startLoading', 'doneLoading']),
    ...mapActions('cashflowView', ['initBudgets']),
    ...mapActions('onboardingState', ['onboardingPageSubmitWithLoading']),
    async finishMonthReview() {
      await this.onboardingPageSubmitWithLoading();
    },
    showFlow() {
      this.showIntro = false;
      this.saveStepInLocalstorage(0);
    },
    onNextClicked({ currentIndex }) {
      this.saveStepInLocalstorage(currentIndex);
    },
    saveStepInLocalstorage(stepIndex) {
      localStorage.setItem(this.localStorageKey, stepIndex);
    },
  },
};
</script>

<style lang="scss" scoped>
.on-boarding-flow-wrapper{
  height: 100%;
}
</style>
